<div class="dialog-content-wrapper">
    <mat-toolbar class="bg-primary m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <ng-container *ngIf="this.title === 'Asignar'; else reasignacion">
                <span class="title dialog-title">Asignación de actuación</span>
            </ng-container>
            <ng-template #reasignacion>
                <span class="title dialog-title">Reasignación de actuación</span>
            </ng-template>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0">
        <diligencia-asignacion-form [idDiligenciaConfig]="this.idDiligenciaConfig" [labelInput]="this.title === 'Asignar' ? 'Asignar a' : 'Reasignar a'"></diligencia-asignacion-form>
    </div>
    <div mat-dialog-actions class="p-24 m-0" fxLayoutAlign="end end">
        <button class="mr-8" mat-raised-button type="button" (click)="dialogRef.close()">
            Cancelar
        </button>
        <ng-container *ngIf="this.title === 'Asignar'; else reasignacionBtn">
            <button [disabled]="!formValid" mat-raised-button type="button" (click)="edit()"
                    color="accent">
                Asignar
            </button>
        </ng-container>
        <ng-template #reasignacionBtn>
            <button [disabled]="!formValid" mat-raised-button type="button" (click)="edit()"
                    color="accent">
                Reasignar
            </button>
        </ng-template>
    </div>
</div>